import { createFileRoute } from "@tanstack/react-router";
import { ThankYouPage } from "@majourneys/booking";

export const Route = createFileRoute("/$lang/_layout/booking/$bookingId/thank-you")({
  component: ThankYouPage,
});
